import React, { useState, useEffect, useRef } from 'react';
import { store } from '../../app/store';
import { postAPI, formatDate, convertTo12Hour } from '../../app/api';
import { useParams } from 'react-router-dom';
import Question from './Question';
import Loader from '../Universal/Loader';
import FaceComponent from './FaceComponent';
import Swal from 'sweetalert2';

export default function ExamAttendComponent({
  onExamStart,
  securityViolations = [],
  logSecurityViolation,
  setLastSaveTime
}) {
  const { public_access_token, org_id, user_unique_id } = useParams();
  const [AttendArr, setAttendArr] = useState([]);
  const [SkipArr, setSkipArr] = useState([]);
  const [ReviewArr, setReviewArr] = useState([]);
  const [PendingArr, setPendingArr] = useState([]);

  const [QuestionLoading, setQuestionLoading] = useState(true);
  const [IsQuestionAnswered, setIsQuestionAnswered] = useState(false);
  const [IsBTNClicked, setIsBTNClicked] = useState(false);
  const [examPresenceSecond, setExamPresenceSecond] = useState(0);
  const [ExamData, setExamData] = useState({});
  const [QuestionData, setQuestionData] = useState([]);
  const [ResultData, setResultData] = useState([]);
  const [Qindex, setQindex] = useState(null);
  const [IsActioned, setIsActioned] = useState(false);
  const [FormData, setFormData] = useState({}); // Changed from [] to {} - used as object not array
  const [Loading, setLoading] = useState(true);
  const [timer, setTimer] = useState("");
  const [timerFlag, setTimerFlag] = useState(true);
  const [endtimer, setEndTimer] = useState("");
  const [endtimerFlag, setEndTimerFlag] = useState(true);
  const [EnrollStartDatetime, setEnrollStartDatetime] = useState("");
  const [EnrollEndDatetime, setEnrollEndDatetime] = useState("");
  const [ExamStartDatetime, setExamStartDatetime] = useState("");
  const [ExamEndDatetime, setExamEndDatetime] = useState("");
  const [PortalStartDatetime, setPortalStartDatetime] = useState("");
  const [PortalEndDatetime, setPortalEndDatetime] = useState("");
  const [ServerTime, setServerTime] = useState("");
  const [ServerTimeDifference, setServerTimeDifference] = useState("");
  const [QArray, setQArray] = useState([]);

  const safeCameraDistanceTotalRef = useRef(0);
  const isFaceVerifiedRef = useRef(0);
  const containerRef = useRef(null);
  const countRef = useRef(0);
  const countFlagRef = useRef(0);
  const timerFlagRef = useRef(0);
  const endTimerFlagRef = useRef(0);
  const [IsSafeCameraDistance, setIsSafeCameraDistance] = useState(false);
  const [isFaceVerified, setIsFaceVerified] = useState(false);
  const [IsExamAttend, setIsExamAttend] = useState(false);

  const [TotalQuestionAttended, setTotalQuestionAttended] = useState(0);
  const [examProgress, setExamProgress] = useState(0);
  const [timeSpentPerQuestion, setTimeSpentPerQuestion] = useState({});
  const [questionStartTime, setQuestionStartTime] = useState(new Date());
  const [autoSaveStatus, setAutoSaveStatus] = useState('saved');
  const [examStats, setExamStats] = useState({
    totalTimeSpent: 0,
    averageTimePerQuestion: 0,
    questionsAttempted: 0,
    questionsSkipped: 0
  });

  function getIndiaTime(datetime) {
    const date = new Date(datetime);
    const indiaTimeString = date.toLocaleString('en-GB', {
      timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    });

    const [day, month, year, hour, minute, second] = indiaTimeString.match(/\d+/g).map(Number);
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}+05:30`;
  }

  useEffect(() => {
    fetchExamData();
    setQuestionStartTime(new Date());
  }, [public_access_token, org_id, user_unique_id]);


  useEffect(() => {
    if (ExamData?.exam_date && ExamData?.exam_start_time && ExamData?.exam_end_time) {
      handleCountdownTimer(`${ExamData.exam_date} ${ExamData.exam_start_time}`);
      handleCountdownEndTimer(`${ExamData.exam_date} ${ExamData.exam_end_time}`);
    }
    fetchResultData(public_access_token);
  }, [ExamData]);

  const handleCountdownTimer = (current_time_str) => {
    if (!current_time_str) return;
    let countDownDate = new Date(current_time_str).getTime();

    let interval = setInterval(() => {
      let now = new Date().getTime();
      let distance = countDownDate - now;
      if (timerFlagRef.current == 0 && distance < 0) {
        if (distance == -1) {
          window.location.reload();
          timerFlagRef.current = 1;
        }
        clearInterval(interval);
        setTimer("");
        setTimerFlag(false);
        return;
      }

      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimer(`${days}d ${hours}h ${minutes}m ${seconds}s`);
      setTimerFlag(true);
    }, 1000);

    return () => clearInterval(interval);
  };

  const handleCountdownEndTimer = (current_time_str) => {
    if (!current_time_str) return;
    let countDownDate = new Date(current_time_str).getTime();

    let interval = setInterval(() => {
      let now = new Date().getTime();
      let distance = countDownDate - now;
      if (endTimerFlagRef.current == 0 && distance < 0) {
        if (distance == -1) endTimerFlagRef.current = 1;
        setEndTimer("Portal Closed.");
        setEndTimerFlag(true);
        clearInterval(interval);
        return;
      }

      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setEndTimer(`${days} day${days > 0 ? 's' : ''} ${hours} hour${hours > 0 ? 's' : ''} ${minutes} minute${minutes > 0 ? 's' : ''} ${seconds} second${seconds > 0 ? 's' : ''}`);
      setEndTimerFlag(false);
    }, 1000);

    return () => clearInterval(interval);
  };

  const fetchExamData = async () => {
    const filter = { org_id: org_id, public_access_token: public_access_token };
    const response = await postAPI("/exams/fetchSingle", filter);
    if (response?.status && response?.data?.length > 0) {
      fetchQuestionData(response.data[0].pre_question_time_in_sec, response.data[0].id);
      setExamData(response.data[0]);
      setEnrollStartDatetime(response.data[0]['enroll_start_date'] + ' ' + response.data[0]['enroll_start_time']);
      setEnrollEndDatetime(response.data[0]['enroll_end_date'] + ' ' + response.data[0]['enroll_end_time']);
      setExamStartDatetime(response.data[0]['exam_date'] + ' ' + response.data[0]['exam_start_time']);
      setExamEndDatetime(response.data[0]['exam_date'] + ' ' + response.data[0]['exam_end_time']);
      setPortalStartDatetime(response.data[0]['portal_start_datetime'].split(".")[0].replace("T", " "));
      setPortalEndDatetime(response.data[0]['portal_end_datetime'].split(".")[0].replace("T", " "));
      setServerTime(getIndiaTime(response.now))
      setServerTimeDifference(Math.abs(new Date() - new Date(response.now)));
    } else {
      setExamData({});
    }
  };



  const fetchQuestionData = async (pre_question_time_in_sec, exam_id) => {
    const filter = { org_id: org_id, exam_id: exam_id, user_unique_id: user_unique_id };
    const response = await postAPI("/questions/exam-wise-list", filter);
    if (response?.status && response?.data?.length > 0) {
      // Properly initialize arrays based on answer status
      const answeredIndices = response.data
        .map((item, index) => ({ item, index }))
        .filter(({ item }) => item.answer_result !== null && item.answer_status !== 'skipped' && item.answer_status !== 'review')
        .map(({ index }) => index);

      const skippedIndices = response.data
        .map((item, index) => ({ item, index }))
        .filter(({ item }) => item.answer_status === 'skipped')
        .map(({ index }) => index);

      const reviewIndices = response.data
        .map((item, index) => ({ item, index }))
        .filter(({ item }) => item.answer_status === 'review')
        .map(({ index }) => index);

      const pendingIndices = response.data
        .map((item, index) => ({ item, index }))
        .filter(({ item }) => item.answer_result === null)
        .map(({ index }) => index);

      if (Qindex === null || Qindex === undefined) {
        setFormData(
          response.data.reduce((acc, item, index) => {
            acc[index] = { ...item, answer: item.answer_result };
            return acc;
          }, {})
        )
        setQindex(skippedIndices[0] || pendingIndices[0] || 0);
      }

      console.log("Answered, Skipped, Review, Pending Indices: ", answeredIndices, skippedIndices, reviewIndices, pendingIndices, "Initial Qindex: ", skippedIndices[0] || pendingIndices[0] || 0);
      // Initialize arrays
      setAttendArr(answeredIndices); // Questions with answers
      setSkipArr(skippedIndices); // Will be updated as user skips
      setReviewArr(reviewIndices); // Will be updated as user marks for review
      setPendingArr(pendingIndices); // Questions not yet attempted

      setLoading(false);
      setQuestionData(response.data);
    } else {
      setQuestionData([]);
    }
  };

  const fetchResultData = async (public_access_token) => {
    setQuestionLoading(true);
    const filter = { org_id: org_id, public_access_token: public_access_token, user_unique_id: user_unique_id };
    const response = await postAPI("/results/user-exam-wise-list", filter);
    if (response?.status && response?.data?.length > 0) {
      setQuestionLoading(false);
      if (response.data[0]?.is_submit) window.location.href = "/CompleteExam";
      setResultData(response.data);
      setFormData(prev => {
        const updatedFormData = { ...prev };
        response.data[0]?.exam_data && Object.keys(response.data[0]?.exam_data).forEach(key => {
          updatedFormData[key] = response.data[0]?.exam_data[key];
        });
        console.log("Fetched FormData: ", FormData);
        console.log("Updated FormData from ResultData: ", updatedFormData);
        return updatedFormData;
      });
      if (FormData?.length > 0 && FormData[Qindex]?.answer) {
        updateResult(public_access_token, parseInt(response.data[0]?.exam_presence_second) + 5);
      }
    } else {
      createResult(public_access_token, 5);
      setResultData([]);
    }
  };

  const updateResult = async (public_access_token, exam_presence_second) => {
    const filter = {
      total_unsafe_area_detected: safeCameraDistanceTotalRef.current,
      is_face_verified: isFaceVerifiedRef.current,
      exam_presence_second: exam_presence_second,
      org_id: org_id,
      public_access_token: public_access_token,
      user_unique_id: user_unique_id,
      exam_data: FormData
    };
    const response = await postAPI("/results/update", filter);
    if (response?.status) {
      setIsBTNClicked(false);
    } else {
      setIsBTNClicked(false);
    }
  };

  const createResult = async (public_access_token, exam_presence_second) => {
    const filter = {
      total_unsafe_area_detected: safeCameraDistanceTotalRef.current,
      is_face_verified: isFaceVerifiedRef.current,
      exam_presence_second: exam_presence_second,
      org_id: org_id,
      public_access_token: public_access_token,
      user_unique_id: user_unique_id,
      exam_data: FormData
    };
    const response = await postAPI("/results/create", filter);
    if (response?.status && response?.data?.last_insert_id > 0) {
      setIsBTNClicked(false);
    } else {
      setIsBTNClicked(false);
    }
  };


  const handleAnswer = async (question_id, answer, temp_action = null) => {
    setIsQuestionAnswered(false);
    setIsBTNClicked(true);
    if (IsBTNClicked) {
    } else {
      const filter = {
        org_id: org_id,
        exam_id: ExamData?.id,
        user_unique_id: user_unique_id,
        question_id: question_id,
        answer: answer,
        answer_status: temp_action || '',
      };
      const response = await postAPI("/exam-result/create", filter);
      if (response?.status && response?.data?.last_insert_id > 0) {
        setIsBTNClicked(false);
      } else {
        setIsBTNClicked(false);
      }
    }
  }



  const handlePrev = () => {
    setIsQuestionAnswered(false);
    recordQuestionTime(Qindex);

    // Track question as visited
    if (FormData[Qindex]?.answer && FormData[Qindex]?.answer.trim() !== '') {
      const TempQArray = QArray;
      if (!TempQArray.includes(Qindex)) {
        TempQArray.push(Qindex);
      }
      setQArray(TempQArray);
      handleAnswer(FormData[Qindex]?.id, FormData[Qindex]?.answer);

      // Update status arrays
      setAttendArr(prev => {
        if (!prev.includes(Qindex)) {
          return [...prev, Qindex];
        }
        return prev;
      });
      setPendingArr(prev => prev.filter(idx => idx !== Qindex));
      setSkipArr(prev => prev.filter(idx => idx !== Qindex));
    } else {
      // Mark as visited but unanswered
      if (!FormData[Qindex]) {
        setFormData(prev => ({
          ...prev,
          [Qindex]: { ...QuestionData[Qindex], answer: '' }
        }));
      }
      // Add to skip array if not already answered
      setSkipArr(prev => {
        if (!prev.includes(Qindex)) {
          return [...prev, Qindex];
        }
        return prev;
      });
      setPendingArr(prev => prev.filter(idx => idx !== Qindex));
    }

    // Navigate to previous question
    let prevIndex = Qindex - 1;
    if (prevIndex >= 0) {
      setQindex(prevIndex);
    }
    setIsActioned(true);
    setQuestionStartTime(new Date());
    updateExamProgress();
  }

  const handleNext = (temp_action) => {
    setIsQuestionAnswered(false);
    recordQuestionTime(Qindex);

    // Update question status tracking arrays
    // if (FormData[Qindex]?.answer && FormData[Qindex]?.answer.trim() !== '') {
    const TempQArray = QArray;
    if (!TempQArray.includes(Qindex)) {
      TempQArray.push(Qindex);
    }
    setQArray(TempQArray);
    handleAnswer(FormData[Qindex]?.id, FormData[Qindex]?.answer, temp_action);

    // Update status arrays based on action
    if (temp_action === 'review') {
      // Mark for review - add to ReviewArr and remove from AttendArr if present
      setReviewArr(prev => {
        const updated = [...prev];
        if (!updated.includes(Qindex)) {
          updated.push(Qindex);
        }
        return updated;
      });
      setAttendArr(prev => prev.filter(idx => idx !== Qindex)); // Remove from answered
    } else if (temp_action === 'submit') {
      // Mark as submitted/answered - add to AttendArr and remove from ReviewArr
      setAttendArr(prev => {
        const updated = [...prev];
        if (!updated.includes(Qindex)) {
          updated.push(Qindex);
        }
        return updated;
      });
      setReviewArr(prev => prev.filter(idx => idx !== Qindex)); // Remove from review
    } else if (temp_action === 'skipped') {
      // Mark as skipped - add to SkipArr and remove from AttendArr and ReviewArr
      setSkipArr(prev => {
        const updated = [...prev];
        if (!updated.includes(Qindex)) {
          updated.push(Qindex);
        }
        return updated;
      });
      setAttendArr(prev => prev.filter(idx => idx !== Qindex)); // Remove from answered
      setReviewArr(prev => prev.filter(idx => idx !== Qindex)); // Remove from review
    }

    // Remove from pending and skip arrays
    setPendingArr(prev => prev.filter(idx => idx !== Qindex));
    setSkipArr(prev => prev.filter(idx => idx !== Qindex));
    // }

    // Navigate to next unanswered question

    const SkippedNext = SkipArr.find(idx => idx > Qindex) || null;
    const PendingNext = PendingArr.find(idx => idx > Qindex) || null;
    let nextIndex = SkippedNext || PendingNext || Qindex + 1;
    while (nextIndex < QuestionData.length &&
      FormData[nextIndex]?.answer &&
      FormData[nextIndex]?.answer.trim() !== '') {
      nextIndex++;
    }

    if (nextIndex >= QuestionData.length) {
      nextIndex = Qindex + 1; // If all remaining are answered, go to next sequential
    }

    setQindex(nextIndex);
    setIsActioned(true);
    setQuestionStartTime(new Date());
    updateExamProgress();
  }

  const handleSkip = () => {
    setIsQuestionAnswered(false);
    recordQuestionTime(Qindex);

    // Mark as visited but not answered (initialize FormData entry)
    if (!FormData[Qindex]) {
      setFormData(prev => ({
        ...prev,
        [Qindex]: { ...QuestionData[Qindex], answer: '' }
      }));
    }

    // Update status arrays - move from Pending to Skipped
    setSkipArr(prev => {
      if (!prev.includes(Qindex)) {
        return [...prev, Qindex];
      }
      return prev;
    });

    setPendingArr(prev => prev.filter(idx => idx !== Qindex));
    setAttendArr(prev => prev.filter(idx => idx !== Qindex)); // Remove from answered if somehow there
    setReviewArr(prev => prev.filter(idx => idx !== Qindex)); // Remove from review

    // Navigate to next unanswered question
    let nextIndex = Qindex + 1;
    while (nextIndex < QuestionData.length &&
      FormData[nextIndex]?.answer &&
      FormData[nextIndex]?.answer.trim() !== '') {
      nextIndex++;
    }

    if (nextIndex >= QuestionData.length) {
      nextIndex = Qindex + 1; // If all remaining are answered, go to next sequential
    }

    setQindex(nextIndex);
    setIsActioned(true);
    setQuestionStartTime(new Date());
    updateExamProgress();
  }

  const recordQuestionTime = (questionIndex) => {
    const currentTime = new Date();
    const timeSpent = Math.round((currentTime - questionStartTime) / 1000); // in seconds

    setTimeSpentPerQuestion(prev => ({
      ...prev,
      [questionIndex]: (prev[questionIndex] || 0) + timeSpent
    }));
  };

  const updateExamProgress = () => {
    const answeredQuestions = Object.keys(FormData).filter(key =>
      FormData[key]?.answer && FormData[key]?.answer.trim() !== ''
    ).length;
    const visitedQuestions = Math.max(Qindex + 1, Object.keys(FormData).length);
    const skippedQuestions = visitedQuestions - answeredQuestions;
    const progress = QuestionData.length > 0 ? Math.round((answeredQuestions / QuestionData.length) * 100) : 0;

    // Debug log to track progress calculation
    console.log('Progress Update:', {
      FormData,
      answeredQuestions,
      visitedQuestions,
      skippedQuestions,
      progress,
      totalQuestions: QuestionData.length
    });

    setExamProgress(progress);
    setTotalQuestionAttended(answeredQuestions);

    setExamStats(prev => ({
      ...prev,
      questionsAttempted: answeredQuestions,
      questionsSkipped: skippedQuestions
    }));
  };

  const autoSaveProgress = async () => {
    setAutoSaveStatus('saving');
    try {
      // Save current progress
      await updateResult(public_access_token, parseInt(ResultData[0]?.exam_presence_second || 0) + 5);
      setAutoSaveStatus('saved');
      if (setLastSaveTime) setLastSaveTime(new Date());
    } catch (error) {
      setAutoSaveStatus('error');
      console.error('Auto-save failed:', error);
    }
  };

  // Update progress when FormData changes
  useEffect(() => {
    if (QuestionData.length > 0) {
      updateExamProgress();
    }
  }, [FormData, QuestionData]);

  // Auto-save every 30 seconds
  useEffect(() => {
    const autoSaveInterval = setInterval(autoSaveProgress, 30000);
    return () => clearInterval(autoSaveInterval);
  }, [ResultData]);

  const handleSubmit = async () => {
    setIsQuestionAnswered(false);
    setIsBTNClicked(true);
    if (IsBTNClicked) {
    } else {
      // Record time for last question
      recordQuestionTime(Qindex);

      // Show confirmation dialog with exam summary
      const totalQuestions = QuestionData.length;
      const answeredQuestions = Object.keys(FormData).filter(key => FormData[key]?.answer).length;
      const skippedQuestions = totalQuestions - answeredQuestions;

      const filter = {
        org_id: org_id,
        exam_id: ExamData?.id,
        user_unique_id: user_unique_id,
        final_stats: examStats,
        time_spent_per_question: timeSpentPerQuestion
      };
      const response = await postAPI("/results/complete", filter);
      if (response?.status) {
        setIsBTNClicked(false);
        window.location.href = "/CompleteExam"
      } else {
        setIsBTNClicked(false);
      }
    }
  }

  const handleQuestionAnswerStatus = async () => {
    setQuestionLoading(true);
    fetchResultData(public_access_token)
  }


  const reloadQuestionWiseAnswer = async (index, QuestionData) => {
    const filter = {
      org_id: org_id,
      user_unique_id: user_unique_id,
      exam_id: ExamData?.id,
      question_id: QuestionData[index]?.id
    };
    const response = await postAPI("/results/fetch-answer", filter);
    if (response?.status && response?.data?.last_insert_id > 0) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [QuestionData[index]?.id]: response?.data?.[0] || {}
      }));
      setIsBTNClicked(false);
    } else {
      setIsBTNClicked(false);
    }
  }



  if (Loading)
    return <Loader />;
  else
    return (
      <>
        {
            ServerTimeDifference > (300 * 1000) ? (
              <div className="d-flex align-items-center justify-content-center h-80vh flex-column text-center">
                <h3 style={{ fontSize: "60px" }}>Global Time Now: <br />
                  <i className='fa fa-calendar-alt' /> {formatDate(ServerTime)?.month} {formatDate(ServerTime)?.day}, {formatDate(ServerTime)?.year} &nbsp; &nbsp; <i className='fa fa-clock' />  {convertTo12Hour(ServerTime.split('.')[0].split("T")[1])}
                </h3>
                {/* <h3 style={{ fontSize: "60px" }}>Now: {ServerTimeDifference}</h3> */}
                <p style={{ fontSize: "14px" }}>Please set your computer time as per global time. </p>
              </div>
            ) : endtimerFlag ? (
              <div className="d-flex align-items-center justify-content-center h-80vh flex-column text-center">
                <h3 style={{ fontSize: "60px" }}>{endtimer}</h3>
                <p style={{ fontSize: "14px" }}>This exam portal has been closed. </p>
              </div>
            ) : timerFlag ? (
              <div className="d-flex align-items-center justify-content-center h-80vh flex-column text-center">
                <h3 style={{ fontSize: "60px" }}>{timer}</h3>
                <p style={{ fontSize: "14px" }}>Exam will start soon. Please Wait ...</p>
              </div>
            ) : (

              <div className="container-fluid h-80vh ExamPortal">
                <div className="row">
                  {/* Questions */}
                  <div className="col-md-9 p-0" ref={containerRef}>
                    <div className='card  mt-1 mb-1'>
                      <div className='row'>
                        <div className="col-md-8">
                          <div className="container-fluid">
                            <h5 className="mt-1 mb-0">{ExamData?.exam_title}</h5>
                            <h5 className=" mb-0">Portal will close In: <span className='fg-red'>{endtimer}</span></h5>

                            {/* Enhanced Progress Bar */}
                            <div className="mb-1">
                              <div className="d-flex justify-content-between mb-1">
                                <small>Exam Progress</small>
                                <small>{examProgress}%</small>
                              </div>
                              <div className="progress" style={{ height: '8px' }}>
                                <div
                                  className="progress-bar progress-bar-striped progress-bar-animated"
                                  role="progressbar"
                                  style={{ width: `${examProgress}%` }}
                                  aria-valuenow={examProgress}
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                ></div>
                              </div>
                            </div>

                            <hr />

                            {/* Security Status */}
                            <div className="row mb-1">
                              <div className="col-md-6">
                                <h6 className=" mb-0">🔐 User Verification: {isFaceVerifiedRef?.current ? <span className='fg-green'>✅ Active</span> : <span className='fg-red'>❌ Failed</span>}</h6>
                              </div>
                              <div className="col-md-6">
                                <h6 className=" mb-0">📏 Safe Distance: {IsSafeCameraDistance ? <span className='fg-green'>✅ Maintained</span> : <span className='fg-red'>❌ Too Close/Far</span>}</h6>
                              </div>
                            </div>

                            {/* Exam Statistics */}
                            <div className="row mb-1">
                              <div className="col-md-3">
                                <h6 className="">📝 Answered: <span className='fg-green'>{AttendArr.length}</span></h6>
                              </div>
                              <div className="col-md-3">
                                <h6 className="">⏭️ Skipped: <span className='fg-orange'>{SkipArr.length}</span></h6>
                              </div>
                              <div className="col-md-2">
                                <h6 className="">Reviewed: <span className='fg-blue'>{ReviewArr.length}</span></h6>
                              </div>
                              <div className="col-md-2">
                                <h6 className="">Pending: <span className='fg-blue'>{PendingArr.length}</span></h6>
                              </div>
                              <div className="col-md-2">
                                <h6 className="">Total: <span className='fg-blue'>{QuestionData.length}</span></h6>
                              </div>
                              {/* <div className="col-md-4">
                                <h6 className="">💾 Auto-save:
                                  {autoSaveStatus === 'saved' && <span className='fg-green'> ✅ Saved</span>}
                                  {autoSaveStatus === 'saving' && <span className='fg-orange'> 🔄 Saving...</span>}
                                  {autoSaveStatus === 'error' && <span className='fg-red'> ❌ Error</span>}
                                </h6>
                              </div> */}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 text-center">
                          <FaceComponent isFaceVerified={isFaceVerified} setIsFaceVerified={setIsFaceVerified} setIsSafeCameraDistance={setIsSafeCameraDistance} safeCameraDistanceTotalRef={safeCameraDistanceTotalRef} isFaceVerifiedRef={isFaceVerifiedRef} public_access_token={public_access_token} org_id={org_id} user_unique_id={user_unique_id} exam_id={ExamData?.id} />
                        </div>
                      </div>
                    </div>
                    {
                      QuestionLoading ?
                        <div className="d-flex align-items-center justify-content-center h-50vh">
                          <Loader />
                        </div>
                        :
                        <div className="row">
                          <div className="container-fluid mb-4">
                            <div className="row">
                              <div className="card">
                                <div className="card-datatable table-responsive p-4">
                                  <Question
                                    SingleQuestionData={QuestionData[Qindex]}
                                    QIndex={Qindex}
                                    FormData={FormData}
                                    setFormData={setFormData}
                                    // setQindex={setQindex}
                                    IsActioned={IsActioned}
                                    IsQuestionAnswered={IsQuestionAnswered}
                                    setIsQuestionAnswered={setIsQuestionAnswered}
                                  />
                                  <div className="text-center mt-4 d-flex justify-content-between">
                                    {Qindex > 0 && (
                                      <button
                                        className="btn btn-primary"
                                        onClick={handlePrev}
                                      >
                                        {IsBTNClicked ? <> <i class="fas fa-circle-notch fa-spin"></i> &nbsp; &nbsp; </> : <></>} Previous
                                      </button>
                                    )}
                                    {Qindex == 0 && (
                                      <div></div>
                                    )}
                                    {Qindex < QuestionData.length - 1 && (
                                      <div className="d-flex gap-2">
                                        {/* Show Skip button when NO answer, else show Review/Next buttons */}
                                        {
                                          (!IsQuestionAnswered && (!FormData[Qindex]?.answer_result || FormData[Qindex]?.answer_result.trim() === '')) ?
                                            <button
                                              className="btn btn-warning"
                                              // onClick={handleSkip}
                                              onClick={() => handleNext('skipped')}
                                            >
                                              Skip
                                            </button>
                                            :
                                            <>
                                              <button
                                                className="btn btn-info"
                                                onClick={() => handleNext('review')}
                                              >
                                                {IsBTNClicked ? <> <i className="fas fa-circle-notch fa-spin"></i> &nbsp; &nbsp; </> : <></>} Review
                                              </button>
                                              <button
                                                className="btn btn-primary"
                                                onClick={() => handleNext('submit')}
                                              >
                                                {IsBTNClicked ? <> <i className="fas fa-circle-notch fa-spin"></i> &nbsp; &nbsp; </> : <></>} Next
                                              </button>
                                            </>
                                        }
                                      </div>
                                    )}
                                    {Qindex == QuestionData.length - 1 && (
                                      <button
                                        className="btn btn-primary"
                                        onClick={handleSubmit}
                                      >
                                        {IsBTNClicked ? <> <i className="fas fa-circle-notch fa-spin"></i> &nbsp; &nbsp; </> : <></>} Submit
                                      </button>
                                    )}
                                    {/* )} */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    }
                  </div>
                  <div className='col-md-3' style={{ paddingRight: "0" }}>
                    <div className="card p-4 mt-1 mb-2">
                      <h6 className="mb-3">📋 Question Navigator</h6>


                      <div className="mb-3">
                        <div className="d-flex flex-wrap gap-2 mt-1">
                          <span className="badge bg-info">📋 Review</span>
                          <span className="badge bg-success">✅ Answered</span>
                          <span className="badge bg-primary">📝 Current</span>
                          <span className="badge bg-danger">⏭️ Skipped</span>
                          <span className="badge bg-secondary">⚪ Not Visited</span>
                        </div>
                      </div>

                      <div className="d-flex flex-wrap" style={{ height: '50vh', overflowY: 'auto' }}>
                        {/* <>
                          AttendArr: {JSON.stringify(AttendArr)}, SkipArr: {JSON.stringify(SkipArr)}, ReviewArr: {JSON.stringify(ReviewArr)}, Qindex: {JSON.stringify(Qindex)}
                          FormData: {JSON.stringify(FormData)}
                        </> */}
                        <div className=''>
                          {AttendArr?.length > 0 && SkipArr?.length > 0 && ReviewArr?.length > 0 && QuestionData.map((_, index) => {
                            const hasAnswer = (FormData[index]?.answer && FormData[index]?.answer.trim() !== '');
                            const isAnswered = AttendArr.includes(index);
                            const isSkipped = SkipArr.includes(index); // Properly check SkipArr
                            const isReviewed = ReviewArr.includes(index); // Check ReviewArr for review status
                            const timeSpent = timeSpentPerQuestion[index] || 0;

                            let buttonClass = '';
                            let statusIcon = '';

                            // Priority order: Reviewed -> Answered -> Current -> Skipped -> Not Visited
                            if (index == Qindex) {
                              buttonClass = 'btn-primary'; // Dark Green for current
                              statusIcon = '📝';
                            } else if (isSkipped) {
                              buttonClass = 'btn-danger'; // Red for skipped
                              statusIcon = '⏭️';
                            } else if (isReviewed && hasAnswer) {
                              buttonClass = 'btn-info'; // Blue for review
                              statusIcon = '🔍';
                            } else if (isAnswered && hasAnswer) {
                              buttonClass = 'btn-success'; // Green for answered
                              statusIcon = '✅';
                            } else {
                              buttonClass = 'btn-secondary'; // Gray for not visited
                              statusIcon = '⚪';
                            }

                            return (
                              <button
                                key={index}
                                className={`btn btn-sm position-relative ${buttonClass} ${hasAnswer} ${isReviewed ? 'reviewed' : ''} ${isSkipped ? 'skipped' : ''} ${hasAnswer ? 'answered' : ''} ${index}-${Qindex}`}
                                style={{ minWidth: "50px", minHeight: "40px", margin: "1px" }}
                                onClick={() => {
                                  if (index !== Qindex) {
                                    // if (index !== Qindex && !hasAnswer) {
                                    recordQuestionTime(Qindex);
                                    setQindex(index);
                                    setIsActioned(true);
                                    setQuestionStartTime(new Date());
                                    handleQuestionAnswerStatus(index, QuestionData);
                                    reloadQuestionWiseAnswer(index, QuestionData);
                                  }
                                }}
                                // disabled={hasAnswer}
                                title={`Question ${index + 1} - ${isReviewed && hasAnswer ? 'Marked for Review' : hasAnswer ? 'Answered' :
                                  index === Qindex ? 'Current' :
                                    isSkipped ? 'Skipped' : 'Not Visited'
                                  }${timeSpent > 0 ? ` - Time: ${Math.floor(timeSpent / 60)}:${(timeSpent % 60).toString().padStart(2, '0')}` : ''}`}
                              >
                                <br />
                                {index + 1}
                                {timeSpent > 60 && (
                                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark" style={{ fontSize: '8px' }}>
                                    {Math.floor(timeSpent / 60)}m
                                  </span>
                                )}
                              </button>
                            );
                          })}
                        </div>
                      </div>

                      <div className="mt-3 pt-3 border-top">
                        <div className="row text-center">
                          <div className="col-4">
                            <div className="text-success"><strong>{AttendArr.length}</strong></div>
                            <small>Answered</small>
                          </div>
                          <div className="col-4">
                            <div className="text-warning"><strong>{SkipArr.length}</strong></div>
                            <small>Skipped</small>
                          </div>
                          <div className="col-4">
                            <div className="text-info"><strong>{PendingArr.length}</strong></div>
                            <small>Remaining</small>
                          </div>
                        </div>
                      </div>

                      {/* {timeSpentPerQuestion[Qindex] && (
                      <div className="mt-2 text-center">
                        <small className="text-muted">
                          Time on this question: {Math.floor(timeSpentPerQuestion[Qindex] / 60)}:{((timeSpentPerQuestion[Qindex] % 60) || 0).toString().padStart(2, '0')}
                        </small>
                      </div>
                    )} */}
                    </div>
                  </div>
                </div>
              </div>
            )
        }
      </>
    );
}
